import { render, staticRenderFns } from "./ActivitySelection.vue?vue&type=template&id=dabf04a6&scoped=true"
import script from "./ActivitySelection.vue?vue&type=script&lang=js"
export * from "./ActivitySelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabf04a6",
  null
  
)

export default component.exports